
import './App.scss';
import RootLayout from './layout/RootLayout';

function App() {
  return (
    <div className="App">


      <RootLayout />
     
    </div>
  );
}

export default App;
